import { render, staticRenderFns } from "./NewChapter.vue?vue&type=template&id=af1c3550&scoped=true"
import script from "./NewChapter.vue?vue&type=script&lang=js"
export * from "./NewChapter.vue?vue&type=script&lang=js"
import style0 from "./NewChapter.vue?vue&type=style&index=0&id=af1c3550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1c3550",
  null
  
)

export default component.exports